import { AppData, Lightning, Log, Registry, Utils } from "@lightningjs/sdk";
import AppModel from "../lib/models/app-model";
import { AppSetup } from "../lib/app-setup";
import { ItemNode } from "../lib/components/grid/ItemNode";
import { FocusManager, ProgressBar } from "@lightningjs/ui-components";
import ControlIcon from "../ui-elements/control-icon";
import { FTPlayerOptions, FTStreamingPlayer } from "../lib/components/ft-streaming-player";
import { events as ftEvents } from "../lib/components/ft-streaming-player/utils";
import { Platform } from "../platforms/platform";
import { fetchData, getDRMSERVICEURL, getDRMURL } from "../lib/models/data-service";
import { Helper } from "../lib/helper";
import { Logger } from "../lib/logger";
import { DRM_TYPE, PLAYERSTATE, ISO_LANGUAGE_MAP } from "../lib/enum";
import { LANGUAGE_TO_ISO_MAP } from "../lib/cc-config";
import { KeyCodes } from "../lib/key-codes";
import VideoPlaylistUI from "../ui-elements/video-playlist";
import { Router } from "@lightningjs/sdk";
import PlayerInfoUI from "../ui-elements/player-info-ui";
import VideoCCSection from "../ui-elements/video-cc-section";
import CCSettingsOverlay from "../ui-elements/cc-settings-overlay";
import { AppApiConfig } from "../lib/app-api-config";
import LableButton from "../ui-elements/lable-button";
import { Config } from "../lib/config";
import VideoMetadataUI from "../ui-elements/video-metadata-ui";
import WatchNextThumbnail from "../ui-elements/watch-next-thumb";
import FTTrickPlayUI from "../lib/components/ft-trickplay/ft-trickplay-ui";
import { ContentPlayer } from "../lib/components/ft-streaming-player/content-player";
import { BugAds } from "../lib/bug-ads";
import { PauseAds } from "../lib/pause-ads";
import VideoTimer from "../ui-elements/videotime";
import CustomProgressBar from "../ui-elements/progress-bar-extended";

export interface VideoScreenNewTypeConfig extends Lightning.Component.TypeConfig {
    IsPage: true;
}

export interface VideoScreenNewTemplateSpec extends Lightning.Component.TemplateSpecLoose {
    Container: {
        ControlWrapper: {}
    }
}

export default class VideoScreenNew
    extends Lightning.Component<VideoScreenNewTemplateSpec, VideoScreenNewTypeConfig>
    implements Lightning.Component<VideoScreenNewTemplateSpec> {

    videoInfo!: ItemNode;
    videoEl!: HTMLVideoElement | null;
    videoElWrapper!: HTMLElement | null;
    platform!: Platform;
    ftStreamingPlayer!: FTStreamingPlayer;
    currentTimeExit = 0;
    isDRM = false;
    isHLS = false;
    isMP4 = false;
    videoUrl = '';
    playerState: PLAYERSTATE = PLAYERSTATE.NONE;
    resumeTime: number = 0;
    isPlaybackStartEventSent = false;
    retries = 0;
    maxRetries = 1;
    isDisconnected = false;
    isPausedOnAd = false;
    screen = '';
    seekMultiplier: number = 0;
    ffRwdSpeed: any = [0, 1, 2, 3, 4, 8, 16];
    finalSeekJumpValue: any;
    ffRewTimerId: any;
    _index = 2;
    buttonIndexMapper!: any;
    controllerOn: boolean = false;
    controlHideIntv: any;
    _rowIndex: number = 1;
    showCC = false;
    subtitlePopupTimeoutId: any = null;
    enableSkip = false;
    checkOnce = false;
    hideControlsOnPlayNext = false;
    creditsWatched = false;
    watchNextTimeOut: any;
    watchNextTimerStarted = false;
    nextItemImageUrl: any;
    preloadNextItemTimer: number | null = null;
    isNavigatingToNextVideo: boolean = false;
    args: any;
    isLoadingBannerVisible: boolean = false;
    errorNextItemTimer: number | null = null;
    prefetched = new Set();
    dragTimerId: any = null;
    isDragging: boolean = false;
    inactivityIntv: any = null;
    _trickPlayToFeedback: boolean = false;
    bugAds: BugAds | null = null;
    pauseAds: PauseAds | null = null;

    progressBar: any
    progressBarCircle: any
    

    override set params(args: any) {
        this.args = args;
    }

    static override _template(): Lightning.Component.Template<VideoScreenNewTemplateSpec> {
        return {
            Container: {
                w: 1920,
                h: 1080,
                collision: true,
                VideoCCSection: {
                    x: 0, y: 0,
                    w: (w: any) => w,
                    h: (h: any) => h,
                    type: VideoCCSection,
                },

                VideoCCOnOffText: {
                    x: (w) => w / 2,
                    y: (h) => h - 260,
                    mountX: 0.5,
                    text: {
                        text: '',
                        fontSize: 42,
                        fontFace: Helper.getFontFamily('Black'),
                        textColor: 0xffff0000
                    }
                },

                ItemInfo: {
                    w: (w: any) => w,
                    h: (h: any) => h,
                    type: PlayerInfoUI,
                },

                CCSettingsOverlay: {
                    type: CCSettingsOverlay,
                    zIndex: 40,
                    visible: false,
                    alpha: 0
                },

                ControlWrapper: {
                    w: 1920,
                    h: 1080,
                    alpha: 0,
                    collision: true,

                    Gradient: {
                        w: (w) => w,
                        h: (h) => h,
                        TopShader: {
                            w: (w) => w,
                            h: (h) => h * 0.4,
                            rect: true,
                            colorTop: 0xFF0D0D1D,
                            colorBottom: 0x003B3B83,
                        },
                        BottomShader: {
                            y: (h) => h,
                            w: (w) => w,
                            h: (h) => h * 0.8,
                            mountY: 1,
                            rect: true,
                            colorTop: 0x003B3B83,
                            colorBottom: 0xFF0D0D1D,
                        },
                    },
                    TitleContainer: {
                        x: 120,
                        y: -30,
                        collision: true,
                        BackButton: {
                            collision: true,
                            x: -66,
                            y: 92,
                            alpha: 0.7,
                            texture: {
                                src: Utils.asset('images/ico-back.png'),
                                resizeMode: { h: 40, w: 40, type: 'contain' },
                                type: Lightning.textures.ImageTexture
                            }
                        },
                        Logo: { y: 82, x: 24 },
                        ItemMetadataWrapper: {
                            y: 152,
                            x: 20,
                            type: VideoMetadataUI,
                        },
                    },

                    Controls: {
                        w: (w) => w,
                        y: 1080,
                        flex: { margin: 0, direction: 'column', alignItems: 'center' },
                        ProgressWrapper: {
                            w: (w) => w - 200,
                            forceZIndexContext: true,
                            collision: true,
                            flex: { margin: 0, direction: 'column', padding: 0, justifyContent: 'center', alignItems: 'center' },
                            TimeWrapper: {
                                y: 3,
                                h: 40,
                                flexItem: {alignSelf: 'flex-end'},
                                mountX:0,
                                zIndex: 1,
                                type: VideoTimer
                            },
                            Progressbar: {
                                y: 10,
                                w: 1920 - 200,
                                zIndex: 1,
                                type: CustomProgressBar,
                                progress: 0,
                                animation: null,
                                style: { height: 10, radius: 0 },
                                Circle: {
                                    mountX: 0.5,
                                    mountY: 0.5,
                                    y: 6.5,
                                    x: 0,
                                    w: 22,
                                    h: 22,
                                    zIndex: 2,
                                    collision: true,
                                    rect: true,
                                    shader: { type: Lightning.shaders.RoundedRectangle, radius: 11 },
                                    color: 0xffffffff,
                                    SpeedLabel: {
                                        mountX: 0.5,
                                        mountY: 0.5,
                                        x: 11,
                                        y: 11,
                                        visible: false,
                                        text: {
                                            text: '',
                                            fontSize: 14,
                                            fontFace: Helper.getFontFamily('Black'),
                                            textColor: 0xff000000,
                                            textAlign: 'center',
                                        }
                                    }
                                }
                            },
                        },

                        MediaButtons: {
                            flexItem: { marginRight: 0 },
                            y: 45,
                            w: (w) => w - 200,
                            type: FocusManager,
                            collision: true,
                            direction: 'row',
                            items: []
                        },

                        // SpeedText: {
                        //     mount: 0,
                        //     x: (w: any) => w - 370,
                        //     y: (h: any) => h - 250,
                        //     w: 350,
                        //     h: 50,
                        //     rect: true,
                        //     color: 0x88000000,
                        //     flexItem: false,
                        //     shader: { type: Lightning.shaders.RoundedRectangle },
                        //     flex: { direction: 'row', justifyContent: 'center', alignItems: 'center' },
                        //     Text: {
                        //         y: 2,
                        //         text: {
                        //             text: '',
                        //             textColor: 0xffffffff,
                        //             fontFace: Helper.getFontFamily('Light'),
                        //             fontSize: 32,
                        //             fontStyle: 'bold',
                        //             textAlign: 'center',
                        //         },
                        //     },
                        //     visible: false,
                        // },

                        VideoPlayList: {
                            w: (w: any) => w,
                            h: (h: any) => h,
                            x: 0,
                            collision: true,
                            type: VideoPlaylistUI,
                            visible: true,
                        },
                    },
                },

                SkipTitles: {
                    type: LableButton,
                    action: '$skipAction',
                    label: 'Skip Intro',
                    fontSize: 32,
                    w: 220,
                    h: 70,
                    x: (w) => 200,
                    // y: (h) => h - 320,
                    collision: true,
                    visible: false,
                },

                FeedbackOverlay: {
                    x: (w) => 100,
                    visible: false,
                    text: {
                        text: '', fontSize: 32, fontFace: Helper.getFontFamily('Regular'), textColor: 0xffffffff,
                    }
                },

                WatchNextThumb: {
                    w: 300,
                    h: 185,
                    x: (w) => w - 400,
                    // y: (h) => h - 530,
                    type: WatchNextThumbnail,
                    action: '$watchNextAction',
                    label: 'WATCH NEXT ▶',
                    collision: true,
                    visible: false,
                },

                FTTrickPlayUI: {
                    x: 0, y: 0,
                    w: (w: any) => w,
                    h: (h: any) => h,
                    visible: true,
                    type: FTTrickPlayUI,
                },
            }
        };
    }

    override _setup() {
        const { appState, platform } = AppData as AppSetup;
        const app: AppModel = appState?.getApp()!;
        app.videoObj = this;
        appState.player.currentUserAction = '';
        this.videoInfo = app.navigation.getCurrentVodInfo();
        this.platform = platform!;
        this.showCC = appState.showSubtitle;
        this.currentTimeExit = 0;
    }

    override _init() {
        const { appState } = AppData as AppSetup;
        this.retries = 0;
        const app = appState?.getApp();
        const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!;
        const textfocuscolor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.textfocuscolor);

        this.setPlayerState(PLAYERSTATE.NONE);

        this.tag('ControlWrapper.TitleContainer').patch({
            Logo: {
                texture: {
                    src: app?.appApiConfig?.appBrandConfig?.header_logo,
                    resizeMode: { h: 60, w: 460, type: 'contain' },
                    type: Lightning.textures.ImageTexture
                },
            },
            ItemMetadataWrapper: { item: this.videoInfo }
        });

        this.tag('VideoCCOnOffText').patch({ textColor: textfocuscolor });
        this.tag('Controls').patch({
            ProgressWrapper: {
                Progressbar: {
                    style: {
                        progressColor: textfocuscolor,
                        barColor: Helper.getHexaColor('#ffffff', 0.22)
                    },
                }
            }
        });
        this.progressBar = this.tag('Progressbar')
        this.progressBarCircle = this.tag('Progressbar.Circle')
        this._addControlButtons();
        //this._setupVideoPlayer();
        this.initTrickplay();
        this.disableCCButton(true);
        this._setState('MediaButtonsState');

        const enableLikeDislike = appApiConfig?.appConfig?.enableLikeDislike;
        if (enableLikeDislike) {
            (this.tag('ControlWrapper.TitleContainer.ItemMetadataWrapper') as VideoMetadataUI)
                .setVideoFeedback(this.videoInfo.node_id, this.videoInfo.likedislike);
            this.tag('FeedbackOverlay').text.text = `Did you like ${this.videoInfo.title  || this.videoInfo.series_name}?`;
        }
    }

    override _active() {
        const { appConfig, appState, platform } = AppData as AppSetup;
        const appApiConfig = appState?.getAppApiConfig();
        const app = appState?.getApp();

        this.isPausedOnAd = false;
        appState.player.videoStartedFromResumePoint = 0;
        appState.player.pausedTime = 0;
        this.isDisconnected = false;
        this.isPlaybackStartEventSent = false;
        this.showHideVideoLoading(true);
        const bugadenabled = appApiConfig?.adsdkConfig.bugAds.bugadenabled;
        this._setupVideoPlayer();
        let resumeTime: any;
        if (this.args?.id && this.args.id.indexOf('_resume') > -1) {
            if (appConfig?.useLocalStorage == true) {
                resumeTime = localStorage.getItem(this.videoInfo.node_id);
            } else {
                resumeTime = Helper.getCookie(this.videoInfo.node_id);
            }
            if (
                resumeTime !== '' &&
                resumeTime !== null &&
                resumeTime !== 0 &&
                resumeTime !== '0' &&
                appApiConfig?.appConfig?.resumeVidMinDuration &&
                this.videoInfo.runtime > appApiConfig.appConfig.resumeVidMinDuration
            ) {
                this.resumeTime = parseInt(resumeTime);
                appState.player.videoStartedFromResumePoint = parseInt(resumeTime);
            }
        } else if (this.args?.id && this.args.id.indexOf('_search') > -1) {
            this.resumeTime = app.navigation.getCurrentPlayingTime();
            appState.player.videoStartedFromResumePoint = parseInt(this.resumeTime);
        }

        const ads = app?.ads;
        appState.gridMode = false;
        appState.videoMode = true;

        if (this.args?.id?.indexOf('_search') == -1) {
            appState.player.noVideosStarted++;
            ads.preRollRequestMade = false;
            const previousVodInfo = app.navigation.getPreviousVideoInfo();
            if (previousVodInfo) {
                Logger.logNextPrevVideoView(this.videoInfo, previousVodInfo);
            } else {
                Logger.logNewVideoView(this.videoInfo);
            }
        }

        // Capture the id of the video we are navigating away from before
        // overwriting it, so BugAds can detect a replay of the same video.
        const previousVideoId = app?.navigation.getPreviousVideoInfo()?.vodInfo?.node_id ?? null;
        app.navigation.setPreviousVideoInfo(this.videoInfo);
        platform?.sendMetrics('startContent', { vodInfo: this.videoInfo });
        this.checkForAds('preroll', this.resumeTime);
        this.preloadNextItemImage();

        if (appConfig?.enableBugAds && bugadenabled) {
            this.bugAds = new BugAds(this.videoInfo, this, previousVideoId);
        }

        if (PauseAds.isEnabled()) {
            this.pauseAds = new PauseAds(this);
        }
    }

    override _detach() {
        this.stage.gc(false);
        if (this.bugAds) {
            this.bugAds.deInit();
            this.bugAds = null;
        }
        if (this.pauseAds) {
            this.pauseAds.deInit();
            this.pauseAds = null;
        }
        if (this.errorNextItemTimer) {
            clearTimeout(this.errorNextItemTimer);
            this.errorNextItemTimer = null;
        }
        if (this.preloadNextItemTimer) {
            clearTimeout(this.preloadNextItemTimer);
            this.preloadNextItemTimer = null;
        }
    }

    override _captureKey(e: KeyboardEvent): boolean | void {
        if (this.playerState === PLAYERSTATE.NONE) return false;

        if (this.bugAds?.adDisplayedStatus) {
            return e.keyCode === KeyCodes.KEY_OK ? false : true;
        }

        if (this.pauseAds?.adDisplayedStatus) {
            const passThroughKeys = [
                KeyCodes.KEY_FORWARD,
                KeyCodes.KEY_REWIND,
                KeyCodes.KEY_EXIT,
                KeyCodes.KEY_HOME,
                KeyCodes.KEY_STOP
            ];
            if (passThroughKeys.includes(e.keyCode)) {
                this.pauseAds.hideAd();
            } else if (e.keyCode === KeyCodes.KEY_OK) {
                this.pauseAds.activate();
                return true;
            } else {
                this.pauseAds.dismissAndResume();
                return true;
            }
        }

        if (!this.controllerOn) {
            const bypassKeys = [
                KeyCodes.KEY_BACK,
                KeyCodes.KEY_BACKSPACE,
                KeyCodes.KEY_EXIT,
                KeyCodes.KEY_HOME,
                KeyCodes.KEY_STOP
            ];
            
            if (bypassKeys.includes(e.keyCode)) {
                return false;
            }

            this.showController();
            return true;
        }
        return false;
    }

    override _handleKey(e: KeyboardEvent): boolean | void {
        if (this.playerState === PLAYERSTATE.NONE) return;
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        if (appState.eventInProgress) return;

        if (this.bugAds?.adDisplayedStatus) {
            if (e.keyCode == KeyCodes.KEY_OK) {
                this.bugAds.executeActions();
            }
            return true;
        }

        let action: string = '';

        switch (e.keyCode) {
            case KeyCodes.KEY_FORWARD: action = '$forward'; break;
            case KeyCodes.KEY_REWIND: action = '$rewind'; break;
            case KeyCodes.KEY_NEXT: action = '$next'; break;
            case KeyCodes.KEY_PREVIOUS:
                action = '$previous';
                this._index = this.buttonIndexMapper[action];
                break;
            case KeyCodes.KEY_PLAY: action = '$playPause'; break;
            case KeyCodes.KEY_PAUSE: action = '$playPause'; break;
            case KeyCodes.KEY_OK:
                if (!this.controllerOn) { action = '$playPause'; }
                else { return; }
                break;
            case KeyCodes.KEY_PLAYPAUSE: action = '$playPause'; break;
            case KeyCodes.KEY_INFO: action = '$info'; break;
            case KeyCodes.KEY_EXIT:
                this.stopFFREWTimer();
                this.hitCloseTracker();
                app?.handleAppExit();
                return true;
            case KeyCodes.KEY_STOP:
                this._handleBack();
                return true;
            case KeyCodes.KEY_HOME:
                this.stopFFREWTimer();
                this.hitCloseTracker();
                Logger.processUserAction('userExitedViaRemoteDirectly', this._getActionKey());
                return true;
            case KeyCodes.KEY_LEFT:
            case KeyCodes.KEY_RIGHT:
                this.showController();
                break;
            default:
                break;
        }

        if (action !== '') {
            if (this.controllerOn) {
                this._index = this.buttonIndexMapper[action];
            }
            if (action == '$playPause') {
                this[action](true, true, e.keyCode);
            } else {
                this[action](true, true);
            }
        }
    }

    override _handleUp(e: KeyboardEvent): boolean | void {
        if (this.playerState === PLAYERSTATE.NONE) return;
        if (this._getState() === 'CCSettingsState') return true;
        const { appState } = AppData as AppSetup;
        if (appState.eventInProgress) return;
        if (this._getState() === 'TrickPlayState') return true;
        if (this.controllerOn) {
            if (this.isTrickplayAvailable()) {
                this.tag('FTTrickPlayUI').show(true);
                this._setState('TrickPlayState');
                this.updateWatchNextThumbPosition();
                this._setState('TrickPlayState');
            } else {
                this.showController(false);
                this.stopFFREWTimer();
            }
        } else {
            this.showController();
        }
    }

    override _handleDown(e: KeyboardEvent): boolean | void {
        if (this.playerState === PLAYERSTATE.NONE) return;
        if (this._getState() === 'CCSettingsState') return true;
        const { appState } = AppData as AppSetup;
        if (appState.eventInProgress) return;

        this.clearControllerTimeout();
        this.tag('FTTrickPlayUI').hide();
        this.updateWatchNextThumbPosition();

        if (this.controllerOn) {
            // Route down through overlays the same way MediaButtonsState does
            const skipVisible  = this.tag('SkipTitles').visible;
            const watchVisible = this.tag('WatchNextThumb').visible;
            if (skipVisible && this.tag('SkipTitles').label === 'SKIP INTRO') {
                this._setState('SkipState');
            } else if (watchVisible) {
                this._setState('WatchNextState');
            } else {
                this._setState('PlaylistState');
            }
            this.stopFFREWTimer();
        } else {
            this.showController();
        }
    }

    override _handleBack(e?: KeyboardEvent): boolean | void {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp() as AppModel;
        const videoInfo = this.videoInfo;

        if (this.playerState === PLAYERSTATE.NONE) return;
        if (
            this.playerState === PLAYERSTATE.PAUSED &&
            this.isPausedOnAd == true &&
            this.screen == 'ad'
        ) return;

        if (this.controllerOn) {
            if (Math.abs(this.seekMultiplier) > 0) {
                this.tag('MediaButtons').selectedIndex = 3;
                this.$playPause();
                this.tag('FTTrickPlayUI').hide();
            }
            if (
                videoInfo.endcredit_st &&
                this.getCurrentTime() >= videoInfo.endcredit_st &&
                this.getCurrentTime() <= videoInfo.endcredit_et
            ) {
                this.hideControlsOnPlayNext = true;
                this.clearWatchNextTimer();
                this.tag('WatchNextThumb').visible = false;
                this.creditsWatched = true;
            }
            this.hideController();
        } else {
            this.clearWatchNextTimer();
            this.handleBackNavigation();
        }
    }

    isTrickplayAvailable() {
        const { appConfig } = AppData as AppSetup;
        return !this.tag('FTTrickPlayUI').trickplayError && appConfig?.enableTrickPlay == true;
    }

    override _getFocused() {
        if (this.bugAds?.adDisplayedStatus) return this;
        if (this.pauseAds?.adDisplayedStatus) return this;
        return this.tag('MediaButtons');
    }

    startInactivityTimer() {
        this.clearInactivityTimer();
        this.inactivityIntv = Registry.setTimeout(() => {
            const state = this._getState();
            if (state === 'PlaylistState' || state === 'TrickPlayState' || state === 'ItemInfoState') {
                this._setState('MediaButtonsState');
                this.hideController();
            } else if (state === 'CCSettingsState') {
                // Mirror manual close ($closeCCOverlay), then fall back to clean playback.
                this.$closeCCOverlay();
                this.hideController();
            }
        }, 10000);
    }

    clearInactivityTimer() {
        if (this.inactivityIntv) {
            clearTimeout(this.inactivityIntv);
            this.inactivityIntv = null;
        }
    }

    $resetInactivityTimer() {
        const state = this._getState();
        if (
            state === 'PlaylistState' ||
            state === 'TrickPlayState' ||
            state === 'ItemInfoState' ||
            state === 'CCSettingsState'
        ) {
            this.startInactivityTimer();
        }
    }

    showController(autoHide = true) {
        this.clearControllerTimeout();
        if (autoHide && !this.enableSkip) {
            this.controlHideIntv = Registry.setTimeout(() => {
                this.hideController();
            }, 10000);
        }
        this.tag('SkipTitles')?.setSmooth('alpha', 1);
        this.tag('ControlWrapper')?.setSmooth('alpha', 1);
        if (this._getState() !== 'PlaylistState') {
            this.tag('Controls')?.setSmooth('y', 800, { duration: 0.4, timingFunction: 'ease-out' });
        }
        this.tag('FeedbackOverlay')?.setSmooth('alpha', 1);
        this.controllerOn = true;
        this._refocus();
    }

    hideController() {
        this.tag('SkipTitles')?.setSmooth('alpha', 0);
        this.tag('ControlWrapper')?.setSmooth('alpha', 0);
        this.tag('Controls')?.setSmooth('y', 1080, { duration: 0.4, timingFunction: 'ease-out' });
        this.tag('FeedbackOverlay')?.setSmooth('alpha', 0);
        this.controllerOn = false;
        this.tag('MediaButtons').selectedIndex = this.buttonIndexMapper['$playPause'];
        this._refocus();
    }

    clearControllerTimeout() {
        clearTimeout(this.controlHideIntv);
        this.controlHideIntv = undefined;
    }

    /**
     * Called by BugAds immediately before a bug ad overlay is shown, so that no
     * player UI sits on top of / competes with the ad. Tears down trickplay,
     * watch-next, skip and closed captions, drops any overlay state back to the
     * base playback state and hides the controller, then moves focus onto the
     * VideoScreen so the bug ad becomes the selectable target (OK ->
     * executeActions). Mirrors the set that isPlayerOverlayVisible() reports.
     * An L-band is the exception for captions: it shrinks the player instead of
     * covering it, and BugAds re-lays the captions onto the smaller video, so they
     * stay on screen (subject to the user's CC setting) rather than being dropped.
     */
    hideOverlaysForBugAd(isLBand = false) {
        this.tag('FTTrickPlayUI')?.hide();
        const watchNext = this.tag('WatchNextThumb');
        if (watchNext) watchNext.visible = false;
        this.disableSkip();
        if (isLBand) {
            this.tag('VideoCCSection')?.controlSubtitleVisibility();
        } else {
            this.tag('VideoCCSection')?.hideSubtitle();
        }
        this.updateWatchNextThumbPosition();
        if (this._getState() !== 'MediaButtonsState') {
            this._setState('MediaButtonsState');
        }
        if (this.controllerOn) this.hideController();
        this._refocus();
    }

    /**
     * Called by BugAds when the ad overlay is removed: brings the closed
     * captions back to their correct persistent state (shown only if the user
     * has subtitles enabled) and returns focus to the normal player controls.
     * Other overlays are intentionally NOT restored - they were user-triggered
     * and stay dismissed.
     */
    restoreCCAfterBugAd() {
        this.tag('VideoCCSection')?.controlSubtitleVisibility();
        this._refocus();
    }

    /**
     * Reports whether any player overlay that a bug ad must not cover is
     * currently on screen: the media controls, trickplay, the playlist, player
     * info (ItemInfo), the CC-settings overlay, the skip (intro/credits) button,
     * the watch-next / end-credits button or the like/dislike feedback overlay.
     * BugAds polls this so a bug ad is only shown over clean playback.
     */
    isPlayerOverlayVisible(): boolean {
        // const overlayStates = [
        //     'PlaylistState',
        //     'ItemInfoState',
        //     'CCSettingsState',
        //     'TrickPlayState',
        //     'SkipState',
        //     'WatchNextState',
        //     'FeedbackState'
        // ];
        return !!(
            this.controllerOn
            || this.tag('FTTrickPlayUI')?.visible
            || this.isInfoOn()
            || this.tag('CCSettingsOverlay')?.visible
            || this.tag('SkipTitles')?.visible
            || this.tag('WatchNextThumb')?.visible
            // || overlayStates.includes(this._getState())
        );
    }

    _setupVideoPlayer() {
        let el = document.getElementById("content-player");
        let elw = document.getElementById('content-player-wrapper');
        let subtitle = document.getElementById('subtitle')
        if(!elw) {
            elw = document.createElement('div');
            elw.setAttribute('id', 'content-player-wrapper')
            elw.setAttribute('style', 'position: absolute;top: 0px;left: 0px;width: 100%;height: 100%;background-color: #000;display:none;')
            document.body.appendChild(elw)
        }
        if (!el) {
            el = document.createElement("video")
            el.id = 'content-player'
            el.style.width = '100%'
            el.style.height = '100%'
            el.setAttribute("crossorigin", "anonymous");
            el.setAttribute("autoplay", "false");
            elw.appendChild(el)
        }
        if(!subtitle) {
            subtitle = document.createElement('div')
            subtitle.id = 'subtitle'
            subtitle.setAttribute('style', 'position: absolute;bottom: 90px;left: 10px;text-align: center;max-width: 1900px;right: 10px;display: none;')
            subtitle.innerHTML = '<span></span>'
            elw.appendChild(subtitle)
        }
        this.videoEl = el as HTMLVideoElement
        this.videoElWrapper = elw as HTMLElement
        Helper.resizePlayer(this.videoEl, 0, 0, 100, 100);
        this.ftStreamingPlayer = FTStreamingPlayer.getInstance(this.videoEl)
        ContentPlayer.getInstance().resetCarouselPreview()
    }

    _setEventListeners() {
        ftEvents.map(event => {
            this.ftStreamingPlayer.addEventListener(event, this._handleFtPlayerEvents);
        });
        this.ftStreamingPlayer.addEventListener('playererror', this._handleFtPlayerEvents);
    }

    _removeEventListener() {
        ftEvents.map(event => {
            this.ftStreamingPlayer.removeEventListener(event, this._handleFtPlayerEvents);
        });
        this.ftStreamingPlayer.removeEventListener('playererror', this._handleFtPlayerEvents);
    }

    _handleFtPlayerEvents = (event: any) => {
        const curTime = Math.round(this.getCurrentTime());
        const durTime = Math.round(this.videoEl!.duration);
        const { appConfig, appState } = AppData as AppSetup;

        if (event.type !== 'progress' && event.type !== 'timeupdate') {
            Log.info('PlayerEvent:', event.type, curTime, durTime);
        }

        switch (event.type) {
            case 'loadedmetadata':
                this.tag('FTTrickPlayUI').setVideoDuration(durTime);
                this.setPlayerState(PLAYERSTATE.READY);
                break;
            case 'pause':
                this.setPlayerState(PLAYERSTATE.PAUSED);
                appState?.sessionTimeState.stopTimer()
                break;
            case 'waiting':
                if (appConfig?.enableNetworkDisconnectionCheck == true) {
                    this._handleNetworkChange();
                }
                this.setPlayerState(PLAYERSTATE.PLAYING);
                break;
            case 'playing':
                if (!this.isPlaybackStartEventSent) {
                    Logger.processUserAction(
                        'playbackStarted',
                        `${this.videoInfo.node_id}_${this.videoInfo.video_format}`
                    );
                    this.isPlaybackStartEventSent = true;
                }
                this.showHideVideoLoading(false);
                this.setPlayerState(PLAYERSTATE.PLAYING)
                appState?.sessionTimeState.startTimer()
                break;
            case 'ended':
                appState?.sessionTimeState.stopTimer()
                this.$next();
                break;
            case 'emptied':
                appState?.sessionTimeState.stopTimer()
                break;
            case 'error':
            case 'playererror':
                this.handlePlayerError(event);
                break;
            case 'timeupdate':
                if (this.currentTimeExit == curTime) return;
                if (
                    this.playerState !== PLAYERSTATE.PLAYING &&
                    this.playerState !== PLAYERSTATE.FF &&
                    this.playerState !== PLAYERSTATE.REW
                ) return;
                if (this.playerState === PLAYERSTATE.PLAYING) {
                    this.currentTimeExit = curTime;
                    this._updateProgress(curTime, durTime);
                    this.updateVideoResumeTime(curTime, durTime, 'videoprogress');
                    this.$videoPlayerTimeUpdate(curTime);
                }
                if (appConfig?.enableTrickPlay) {
                    const trickplayTime = (this.playerState === PLAYERSTATE.FF || this.playerState === PLAYERSTATE.REW)
                        ? Math.round(this.finalSeekJumpValue)
                        : curTime;
                    this.tag('FTTrickPlayUI').setPlayerTime(trickplayTime);
                }
                break;
        }
    };

    async _resumePlayer(resumeTime = 0) {
        Log.info('videoInfo ', this.videoInfo);
        const { appConfig } = AppData as AppSetup;
        const options = new FTPlayerOptions();

        this.isDRM = false;
        this.isHLS = false;
        this.isMP4 = false;

        if (this.videoInfo) {
            if (this.videoInfo.drm == 1) {
                this.isDRM = true;
                this.videoUrl = this.videoInfo.video_url;
            } else if (this.videoInfo.video_format == 'hls') {
                this.isHLS = true;
                this.videoUrl = this.videoInfo.video_hls_url!;
            } else if (this.videoInfo.video_format == 'mp4') {
                this.isMP4 = true;
                this.videoUrl = this.videoInfo.video_url;
            }
        }

        Log.info('videoUrl ', this.videoUrl);
        this.setPlayerState(PLAYERSTATE.INITIALIZING);

        let drm;
        if (appConfig?.useDRMProxy) {
            drm = await Helper.getDrmProxyObj(this.videoInfo);
        } else {
            drm = await Helper.getDrmObj(this.videoInfo);
        }

        const hlsOptions = this.platform.getHlsOptions();
        options.dash.drm = drm;
        options.startTime = parseInt(resumeTime);

        const mp4Url = { src: this.videoInfo.video_url, type: 'video/mp4', options };
        const hlsUrl = { src: this.videoInfo.video_hls_url, type: 'application/x-mpegURL', options };
        const dashUrl = {
            src: (this.videoInfo.video_format == 'mpd' ? this.videoInfo.video_url : null) || null,
            type: 'application/dash+xml',
            options
        };

        let src: any;
        if (dashUrl.src !== null) {
            src = dashUrl;
        } else if (hlsUrl.src !== null) {
            options.hls = hlsOptions;
            src = hlsUrl;
        } else {
            src = mp4Url;
        }

        if (appConfig?.testVideoError) {
            src.src = 'https://video_404';
        }

        this._removeEventListener();
        this._setEventListeners();
        this.ftStreamingPlayer.src = src;
        this.ftStreamingPlayer.play();
        const { ccOptions } = AppData as AppSetup;
        const multiLangTracks = appConfig?.enableMultilangCC ? (this.videoInfo.cc_path_multi_lang || []) : [];
        const resolvedLang = ccOptions.updateLanguageOptions(multiLangTracks, this.videoInfo.cc_default_lang);
        this.$ccLanguageChange(resolvedLang);
        this.showVideo();
        this.showController();
    }

    getDrmProxyObj = (videoInfo: any) => {
        return new Promise((resolve) => {
            if (videoInfo.drm == 1) {
                const drm = {
                    'com.widevine.alpha': {
                        serverURL: getDRMSERVICEURL(DRM_TYPE.WIDEVINE),
                        audioRobustness: 'SW_SECURE_CRYPTO',
                        videoRobustness: 'SW_SECURE_DECODE',
                        priority: 0,
                    },
                    'com.microsoft.playready': {
                        serverURL: getDRMSERVICEURL(DRM_TYPE.PLAYREADY),
                        audioRobustness: 'SW_SECURE_CRYPTO',
                        videoRobustness: 'SW_SECURE_DECODE',
                        priority: 1,
                    },
                };
                resolve(drm);
            } else {
                resolve(null);
            }
        });
    };

    getDrmObj = (videoInfo: any) => {
        const { appConfig } = AppData as AppSetup;
        return new Promise((resolve) => {
            if (videoInfo.drm == 1) {
                const url = getDRMURL();
                fetchData(url).then((response: any) => {
                    if (response && response.data) {
                        const drm = {
                            'com.widevine.alpha': {
                                serverURL: appConfig?.drmInfo.widevineLisenceUrl,
                                httpRequestHeaders: { customdata: response.data.customdata },
                                audioRobustness: 'SW_SECURE_CRYPTO',
                                videoRobustness: 'SW_SECURE_DECODE',
                                priority: 0,
                            },
                            'com.microsoft.playready': {
                                serverURL: appConfig?.drmInfo.playreadyLisenceUrl,
                                httpRequestHeaders: { customdata: response.data.customdata },
                                audioRobustness: 'SW_SECURE_CRYPTO',
                                videoRobustness: 'SW_SECURE_DECODE',
                                priority: 1,
                            },
                        };
                        resolve(drm);
                    } else {
                        resolve(null);
                    }
                });
            } else {
                resolve(null);
            }
        });
    };

    setPlayerState(playerState: PLAYERSTATE) {
        const { appState } = AppData as AppSetup;

        if (playerState == PLAYERSTATE.READY) {
            appState.eventInProgress = false;
            //this.showHideVideoLoading(false);
            if (!this.videoInfo.runtime) {
                this.videoInfo.runtime = Math.round(this.videoEl?.duration!);
            }
        } else if (this.playerState == PLAYERSTATE.FF || this.playerState == PLAYERSTATE.REW) {
            if (playerState == PLAYERSTATE.FF) {
                this.tag('MediaButtons').items[this.buttonIndexMapper['$playPause']].stateIndex = 0;
                this.tag('MediaButtons').selectedIndex = this.buttonIndexMapper['$forward'];
            } else if (playerState == PLAYERSTATE.REW) {
                this.tag('MediaButtons').items[this.buttonIndexMapper['$playPause']].stateIndex = 0;
                this.tag('MediaButtons').selectedIndex = this.buttonIndexMapper['$rewind'];
            }
        } else if (playerState == PLAYERSTATE.PLAYING) {
            //this.showHideVideoLoading(false);
            this.tag('MediaButtons').items[this.buttonIndexMapper['$playPause']].stateIndex = 1;
            this.tag('MediaButtons').selectedIndex = this.buttonIndexMapper['$playPause'];
        } else if (playerState == PLAYERSTATE.PAUSED) {
            this.tag('MediaButtons').items[this.buttonIndexMapper['$playPause']].stateIndex = 0;
            this.tag('MediaButtons').selectedIndex = this.buttonIndexMapper['$playPause'];
        } else if (playerState == PLAYERSTATE.FF) {
            this.tag('MediaButtons').items[this.buttonIndexMapper['$playPause']].stateIndex = 0;
            this.tag('MediaButtons').selectedIndex = this.buttonIndexMapper['$forward'];
        } else if (playerState == PLAYERSTATE.REW) {
            this.tag('MediaButtons').items[this.buttonIndexMapper['$playPause']].stateIndex = 0;
            this.tag('MediaButtons').selectedIndex = this.buttonIndexMapper['$rewind'];
        }

        this.playerState = playerState;
        this.notifyPauseAds(playerState);
    }

    /**
     * Drive the on-pause ad off the player state rather than the element's pause
     * event, so every route into a pause - remote PAUSE/OK, the on-screen button,
     * a platform-level pause - schedules it from one place.
     *
     * Trickplay and ad breaks also leave the element paused without the viewer
     * having chosen to stop watching, so they are filtered out here: FF/REW keep
     * seekMultiplier non-zero, an ad break sets isPausedOnAd/screen, and a bug ad
     * already owns the screen if one is up. Anything that is not an eligible pause
     * is reported as a resume, which is what cancels a pending or on-screen ad.
     */
    notifyPauseAds(playerState: PLAYERSTATE) {
        if (!this.pauseAds) return;
        const { appState } = AppData as AppSetup;
        const eligible = playerState === PLAYERSTATE.PAUSED
            && this.seekMultiplier === 0
            && this.isPausedOnAd === false
            && this.screen !== 'ad'
            && this.videoEl?.ended !== true
            && appState?.getApp()?.ads?.midAdPlaying !== true
            && !this.bugAds?.adDisplayedStatus;

        if (eligible) {
            this.pauseAds.onPaused();
        } else {
            this.pauseAds.onResumed();
        }
    }

    /**
     * Called by PauseAds once the banner is on screen so _getFocused() is
     * re-evaluated and the ad becomes the input target. The controller is left
     * exactly as it is - the banner only occupies the right edge, and any key
     * press dismisses it and resumes, so the controls never have to be torn down
     * for it the way they are for a bug ad.
     */
    onPauseAdShown() {
        this._refocus();
    }

    /** Called by PauseAds once the banner is gone; hands input back to the controls. */
    onPauseAdHidden() {
        this._refocus();
    }

    /**
     * Close-and-continue path for the pause ad: resume exactly as if the viewer
     * had pressed play, so the controller, watch-next and progress behave as
     * normal. KEY_PLAY is passed so this can only ever resume, never toggle back
     * to paused on a stale state.
     */
    resumeFromPauseAd() {
        if (this.playerState === PLAYERSTATE.PAUSED) {
            this.$playPause(true, true, KeyCodes.KEY_PLAY);
        } else {
            this._refocus();
        }
    }

    updatePlayerState() {
        const playerState =
            this.videoEl?.paused || this.videoEl?.ended
                ? PLAYERSTATE.PAUSED
                : PLAYERSTATE.PLAYING;
        this.setPlayerState(playerState);
    }

    _updateProgress(cur: number, dur: number) {
        const progress = (cur / dur)
        const progressWidth = 1920 - 200;
        this.tag('TimeWrapper').setDuration(dur)
        this.tag('TimeWrapper').updateProgress(cur)
        // this.tag('ControlWrapper').patch({
        //     Controls: {
        //         ProgressWrapper: {
        //             Progressbar: { 
        //                 progress,
        //                 Circle: { x: progress * progressWidth }
        //             }
        //         }
        //     }
        // });
        this.progressBar.progress = progress
        this.progressBarCircle.x = progress * progressWidth
    }

    showHideVideoLoading(state: boolean) {
        this.widgets.loadingscreen.showVideoLoadingScreen(state);
        this.isLoadingBannerVisible = state;
        if (state) this.tag('FTTrickPlayUI').hide();
    }

    showVideo() {
        if ($('#content-player-wrapper')) $('#content-player-wrapper').show();
    }

    hideVideo() {
        if ($('#content-player-wrapper')) $('#content-player-wrapper').hide();
    }

    disableCCButton(state: boolean) {
        const { appConfig } = AppData as AppSetup;
        if (appConfig.disableCC) return;
        if (!state) this.showHideSubtitleState(this.showCC);
        this.tag('MediaButtons').items[this.buttonIndexMapper['$closedcaption']].skipFocus = state;
        this.tag('MediaButtons').items[this.buttonIndexMapper['$closedcaption']]._update();
    }

    showHideSubtitleState(state: boolean) {
        const { appState, appConfig } = AppData as AppSetup;
        if (appConfig.disableCC) {
            this.showCC = false;
            appState.showSubtitle = false;
            return;
        }
        appState.showSubtitle = state;
        this.showCC = state;
        this.tag('MediaButtons').items[this.buttonIndexMapper['$closedcaption']].stateIndex = state ? 0 : 1;
        this.tag('VideoCCSection').controlSubtitleVisibility();
    }

    showSubtitlePopup(text: string) {
        this.tag('VideoCCOnOffText').patch({ visible: true, text: { text } });
        if (this.subtitlePopupTimeoutId) clearTimeout(this.subtitlePopupTimeoutId);
        this.subtitlePopupTimeoutId = setTimeout(() => {
            this.tag('VideoCCOnOffText').visible = false;
            this.subtitlePopupTimeoutId = null;
        }, 1000);
    }

    initTrickplay() {
        this.tag('FTTrickPlayUI').destroy();
        this.tag('FTTrickPlayUI').initTrickplay(this.videoInfo, this);
    }

    trickplaySelectedHandler(event: any) {
        this.stopFFREWTimer();
        this.seekMultiplier = 0;
        this.finalSeekJumpValue = 0;
        this.currentTimeExit = event.detail || 1;
        this.setCurrentTime(this.currentTimeExit); 
        Logger.processUserAction('trickplay_selected_' + event.detail, this._getActionKey());
        this.ftStreamingPlayer.play();
        this.setPlayerState(PLAYERSTATE.PLAYING);  
        this.tag('FTTrickPlayUI').hide();
        this.updateWatchNextThumbPosition();
        this.showController(true);
        this._setState('MediaButtonsState');
    }

    trickplayAutoHideHandler(_event: any) {
        if (this._getState() === 'TrickPlayState') {
            return;
        }

        this.tag('MediaButtons').selectedIndex = 3;
        this.seekMultiplier = 0;
        this.stopFFREWTimer();
        this.updatePlayerState();
        this.tag('FTTrickPlayUI').hide();
        this.updateWatchNextThumbPosition();
        this.updateFeedbackPosition();
        this.showController(false);
        this._setState('MediaButtonsState');
        this._refocus();
        this.clearControllerTimeout();
        this.controlHideIntv = Registry.setTimeout(() => {
            this.hideController();
        }, 10000);
    }

    $playPause(isUserAction = false, isRemote = false, keyCode = 0) {
        this.clearWatchNextTimer();
        if (this.playerState === PLAYERSTATE.PLAYING) {
            this.showController(false);
        } else {
            this.showController(true);
        }
        this.stopFFREWTimer();

        if (Math.abs(this.seekMultiplier) > 0) {
             this.tag('FTTrickPlayUI').hide();
            this.tag('FTTrickPlayUI').hide();
            this.updateWatchNextThumbPosition();
            this.currentTimeExit = this.finalSeekJumpValue;
            this.seekMultiplier = 0;
            this.setCurrentTime(this.finalSeekJumpValue);
        }

        let actionToPerform = this.playerState == PLAYERSTATE.PLAYING ? 'pause' : 'play';
        if (isUserAction && isRemote) {
            if (keyCode == KeyCodes.KEY_PLAY) actionToPerform = 'play';
            else if (keyCode == KeyCodes.KEY_PAUSE) actionToPerform = 'pause';
            else actionToPerform = this.playerState == PLAYERSTATE.PLAYING ? 'pause' : 'play';
        }

        if (actionToPerform == 'play') {
            this.ftStreamingPlayer.play();
            this.setPlayerState(PLAYERSTATE.PLAYING);
            this.updateWatchNextThumbPosition();
            this.tag('WatchNextThumb').startProgress();
        } else {
            this.ftStreamingPlayer.pause();
            this.setPlayerState(PLAYERSTATE.PAUSED);
        }

        Logger.processUserAction(
            'playPausePressedOnVideoPlayer_' + (isUserAction ? 'user' : 'auto'),
            this._getActionKey()
        );
    }

    $previous(isUserAction = false, isRemote = false) {
        this.clearWatchNextTimer();
        Logger.processUserAction(
            isRemote ? 'previousButtonPressedOnRemote' : 'previousVideoButtonPressedOnPlayerUI',
            this._getActionKey
        );
        const { appState } = AppData as AppSetup;
        this.stopFFREWTimer();
        appState.player.pausedTime = 0;
        appState.player.videoStartedFromResumePoint = 0;
        appState.player.currentUserAction = 'previous';
        if (Math.abs(this.seekMultiplier) > 0) {
            this.tag('FTTrickPlayUI').hide();
            this.updateWatchNextThumbPosition();
        }
        this.playPreviousVideo();
    }

    $next(isUserAction = false, isRemote = false) {
        this.clearWatchNextTimer();
        const { appState } = AppData as AppSetup;
        this.stopFFREWTimer();
        appState.player.pausedTime = 0;
        appState.player.videoStartedFromResumePoint = 0;

        let action = isRemote ? 'nextButtonPressedOnRemote' : 'nextVideoButtonPressedOnPlayerUI';
        let isautoplay = false;
        if (!isUserAction && !isRemote) {
            action = 'autoPlayingNextVideoOnComplete';
            appState.player.noVideosPlayed += 1;
        }
        Logger.processUserAction(action, this._getActionKey());
        appState.player.currentUserAction = 'next';
        if (Math.abs(this.seekMultiplier) > 0) {
            this.tag('FTTrickPlayUI').hide();
            this.updateWatchNextThumbPosition();
        }
        this.playNextVideo(isautoplay);
    }

    $forward(isUserAction = false, isRemote = false) {
        this.clearWatchNextTimer();
        this.pauseAds?.onResumed();
        if (this.isLoadingBannerVisible || this._rowIndex == 2) return;
        this.showController(false);
        if (this.seekMultiplier == 0) this.finalSeekJumpValue = this.getCurrentTime();
        this.ftStreamingPlayer.pause();
        this.setPlayerState(PLAYERSTATE.FF);
        this.startFFREWTimer();
        this.tag('WatchNextThumb').startProgress();
        if (this.isTrickplayAvailable()) {
            this.tag('Controls').patch({
                smooth: { y: [900, { duration: 0.3, timingFunction: 'ease-out' }] }
            });
        }
        const maxFFlength = this.ffRwdSpeed.length - 1;
        if (this.seekMultiplier <= 0) {
            this.seekMultiplier = 1;
        } else if (this.seekMultiplier > 0 && this.seekMultiplier <= maxFFlength) {
            this.seekMultiplier = this.seekMultiplier == maxFFlength ? 1 : this.seekMultiplier + 1;
        }

        Logger.processUserAction(
            (isRemote ? 'forwardButtonPressedOnRemote_' : 'forwardButtonPressedOnPlayerUI_') + this.ffRwdSpeed[this.seekMultiplier],
            this._getActionKey()
        );
    }

    $rewind(isUserAction = false, isRemote = false) {
        this.clearWatchNextTimer();
        this.pauseAds?.onResumed();
        if (this.isLoadingBannerVisible || this._rowIndex == 2) return;
        if (this.tag('WatchNextThumb').visible) {
            this.tag('FeedbackOverlay').setSmooth('alpha', 0);
            this.tag('FeedbackOverlay').patch({ visible: false });
            this._videoFeedback.setSmooth('alpha', 0);
        }
        this.showController(false);
        this.tag('WatchNextThumb').visible = false;
        if (this.seekMultiplier == 0) this.finalSeekJumpValue = this.getCurrentTime();
        this.ftStreamingPlayer.pause();
        this.setPlayerState(PLAYERSTATE.REW);
        this.startFFREWTimer();
        this.tag('WatchNextThumb').startProgress();
        if (this.isTrickplayAvailable()) {
            this.tag('Controls').patch({
                smooth: { y: [900, { duration: 0.3, timingFunction: 'ease-out' }] }
            });
        }
        const maxFFlength = this.ffRwdSpeed.length - 1;
        if (this.seekMultiplier >= 0) {
            this.seekMultiplier = -1;
        } else if (this.seekMultiplier < 0 && Math.abs(this.seekMultiplier) <= maxFFlength) {
            this.seekMultiplier = Math.abs(this.seekMultiplier) == maxFFlength ? -1 : this.seekMultiplier - 1;
        }

        Logger.processUserAction(
            (isRemote ? 'rewindButtonPressedOnRemote_' : 'rewindButtonPressedOnPlayerUI_') + this.ffRwdSpeed[this.seekMultiplier * -1],
            this._getActionKey()
        );
    }

    $search(isUserAction = false, isRemote = false) {
        this.clearWatchNextTimer();
        Logger.processUserAction('showSearchPageOnPlayerUI', this._getActionKey());
        this.stopFFREWTimer();
        const { appState, appConfig } = AppData as AppSetup;
        const app: AppModel = appState?.getApp()!;
        app.navigation.setCurrentPlayingTime(this.currentTimeExit);
        appState.player.videoStartedFromResumePoint = this.currentTimeExit;
        appState.player.pausedTime = this.currentTimeExit;
        appState?.sessionTimeState.stopTimer()
        this.closeVideo(true);
        appConfig.searchInput = appConfig.defaultSearchInput;
        appConfig.useHistory = false;
        if (Math.abs(this.seekMultiplier) > 0) {
            this.tag('FTTrickPlayUI').hide();
            this.updateWatchNextThumbPosition();
        }
        Router.navigate('search-screen/player', false);
    }

    $restart(isUserAction = false, isRemote = false) {
        this.clearWatchNextTimer();
        this.clearInactivityTimer();
        Logger.processUserAction('restartButtonPressedOnVideoPlayer', this._getActionKey());
        this.stopFFREWTimer();
        this.seekMultiplier = 0;
        this.finalSeekJumpValue = 0;
        this.currentTimeExit = 0;
        this.resumeTime = 0;
        this.creditsWatched = false;
        this.watchNextTimerStarted = false;
        this.hideControlsOnPlayNext = false;
        this.checkOnce = false;
        this.tag('FTTrickPlayUI').hide();
        this.tag('WatchNextThumb').visible = false;
        this.showSkipButton(false);
        this.updateWatchNextThumbPosition();
        this.updateFeedbackPosition()
        this.setCurrentTime(0);
        this.ftStreamingPlayer.play();
        this.setPlayerState(PLAYERSTATE.PLAYING);
        this._setState('MediaButtonsState');
        this.showController(true);
    }

    $info(isUserAction = false, isRemote = false) {
        this.clearWatchNextTimer();
        if (this._rowIndex == 2) return;

        if (!this.isInfoOn()) {
            this.hideController();
            this.tag('WatchNextThumb').visible = false;
            Logger.processUserAction('showInfoWindowOnPlayerUI', this._getActionKey());
            this.tag('MediaButtons').selectedIndex = this.buttonIndexMapper['$info'];
            this.tag('ItemInfo').item = this.videoInfo;
            this.tag('ItemInfo').show();
            this._setState('ItemInfoState');
            this.tag('FTTrickPlayUI').hide();
            if (Math.abs(this.seekMultiplier) > 0) this.$playPause();
        } else {
            this.showController();
            this.tag('WatchNextThumb').visible = true;
            this.updateFeedbackPosition();
            this.updateWatchNextThumbPosition();
            Logger.processUserAction('hideInfoWindowOnPlayerUI', this._getActionKey());
            this._setState('MediaButtonsState');
            this._refocus();
        }
    }

    isInfoOn() {
        return this.tag('ItemInfo').isVisible;
    }

    $closedcaption(isUserAction = false, isRemote = false) {
        this.clearWatchNextTimer();
        if (Math.abs(this.seekMultiplier) > 0) {
            this.$playPause();
        }
        this.hideController()
        this.tag("FTTrickPlayUI").hide();
        this._setState('CCSettingsState')
    }

    $closeCCOverlay() {
        this._setState('')
    }

    $ccLanguageChange(langCode: string) {
        Log.info('VideoScreenNew: $ccLanguageChange', langCode);
        const ccDefaultLangIso = LANGUAGE_TO_ISO_MAP[(this.videoInfo.cc_default_lang || 'en').toLowerCase()] || 'en';
        if (langCode === ccDefaultLangIso) {
            if (this.videoInfo.cc_path) {
                this.tag('VideoCCSection').addCaption(this.videoInfo.cc_path, this);
            }
            return;
        }
        const multiLangTracks = this.videoInfo.cc_path_multi_lang || [];
        const mappedLang = ISO_LANGUAGE_MAP[langCode as keyof typeof ISO_LANGUAGE_MAP] || langCode;
        const match = multiLangTracks.find((t: any) => {
            const trackLangLower = t.language?.toLowerCase() || '';
            return trackLangLower === langCode.toLowerCase() || trackLangLower === mappedLang.toLowerCase();
        });
        const ccPath = match ? match.file_path : this.videoInfo.cc_path;
        Log.info('VideoScreenNew: $ccLanguageChange swapping track to', ccPath);
        if (ccPath) this.tag('VideoCCSection').addCaption(ccPath, this);
    }

    $ccToggle(state: any) {
        this.showCC = state
        const popupText = this.showCC ? "Subtitle On" : "Subtitle Off";
        this.showSubtitlePopup(popupText);
        if (this.showCC) {
            Logger.processUserAction("closedCaptionsShown", this._getActionKey());
        } else {
            Logger.processUserAction("closedCaptionsHidden", this._getActionKey());
        }
        this.showHideSubtitleState(state)
    }

    $hide() {
        this._rowIndex = 1;
        this.showController();
        this._setState('MediaButtonsState');
    }

    $reset() {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        this.showHideVideoLoading(true);
        this.sendMetricsOnEnd();
        this.ftStreamingPlayer.pause();
        app.navigation.setPreviousVideoWatchDuration(Math.round(this.currentTimeExit));
        this.resetAds();
        this.resetPlayer();
    }

    $ItemChanged() {
        this._index = this.tag('MediaButtons').selectedIndex;
    }

    $ItemSelected(action: string) {
        if (this.playerState === PLAYERSTATE.NONE) return;
        this[action](true);
    }

    $skipAction() {
        this.checkOnce = false;
        const videoInfo = this.videoInfo;
        const curTime = Math.round(this.getCurrentTime());
        this.showSkipButton(false);
        this.showController();
        this._setState('MediaButtonsState');

        if (curTime > videoInfo.intro_st && curTime <= videoInfo.intro_et) {
            Logger.processUserAction('skipIntroButtonPressedOnVideoPlayer_SkippingIntro', this._getActionKey());
            this.setCurrentTime(videoInfo.intro_et + 1);
        } else if (curTime > videoInfo.endcredit_st && curTime <= videoInfo.endcredit_et) {
            Logger.processUserAction('skipCreditButtonPressedOnVideoPlayer_WatchingCredits', this._getActionKey());
            this.clearWatchNextTimer();
            this.hideController();
            this.tag('WatchNextThumb').visible = false;
            this.creditsWatched = true;
        }

        if (this.playerState == PLAYERSTATE.PAUSED) this.ftStreamingPlayer.play();

        this.clearControllerTimeout();
        this.controlHideIntv = Registry.setTimeout(() => { this.hideController(); }, 10000);
    }

    updateSkipIntroAndCredits = (curTime: any) => {
        const { appState } = AppData as AppSetup;
        if (this.bugAds?.adDisplayedStatus) return;
        const appApiConfig = appState?.getAppApiConfig();
        const resumeVidMinDuration = appApiConfig?.appConfig?.resumeVidMinDuration;
        const videoInfo = this.videoInfo;

        if (videoInfo.intro_et || videoInfo.endcredit_st) {
            if (
                this.creditsWatched &&
                videoInfo.endcredit_st &&
                curTime >= videoInfo.endcredit_st &&
                curTime <= videoInfo.endcredit_et
            ) {
                this.tag('WatchNextThumb').visible = false;
                this.updateFeedbackPosition();
                this.disableSkip();
                this.clearWatchNextTimer();
                return;
            }

            const inIntro = videoInfo.intro_et && curTime > videoInfo.intro_st && curTime <= videoInfo.intro_et;
            const inCredits = videoInfo.endcredit_st && curTime >= videoInfo.endcredit_st && curTime <= videoInfo.endcredit_et;

            if (inIntro || inCredits) {
                if (inCredits) {
                    this.tag('SkipTitles').label = 'WATCH CREDITS';
                    this.tag('SkipTitles').x = 1920 - 400;
                    this.tag('SkipTitles').w = 300;
                    if (!this.hideControlsOnPlayNext) {
                        this.showController(false);
                        if (!this.watchNextTimerStarted) {
                            if (this.nextItemImageUrl) this.tag('WatchNextThumb').imgSrc = this.nextItemImageUrl;
                            this.tag('WatchNextThumb').visible = true;
                             this.updateFeedbackPosition();
                            this.updateWatchNextThumbPosition();
                            this.watchNextTimer();
                            this.watchNextTimerStarted = true;
                        }
                        this.tag('WatchNextThumb').startProgress();
                    }
                }
                if (inIntro) {
                    this.tag('WatchNextThumb').visible = false;
                    this.tag('SkipTitles').label = 'SKIP INTRO';
                    this.tag('SkipTitles').x = 100;
                    this.tag('SkipTitles').w = 220;
                }
                this.showSkipButton(true);
                this.enableSkip = true;
                this.focusFirstTime();
                this.clearControllerTimeout();
            } else {
                this.tag('WatchNextThumb').visible = false;
                 this.updateFeedbackPosition();
                this.disableSkip();
                this.clearWatchNextTimer();
                this.hideControlsOnPlayNext = false;
            }
        } else if (videoInfo.menudisplay_st) {
            if (
                curTime >= videoInfo.menudisplay_st &&
                curTime <= videoInfo.runtime &&
                resumeVidMinDuration &&
                videoInfo.runtime > resumeVidMinDuration
            ) {
                if (!this.hideControlsOnPlayNext) {
                    this.showController(false);
                    this.clearControllerTimeout();
                }
            } else {
                this.hideControlsOnPlayNext = false;
            }
        }
    };

    get _videoFeedback() {
        return (this.tag('ControlWrapper.TitleContainer.ItemMetadataWrapper') as VideoMetadataUI).feedbackTag;
    }

    updateFeedbackPosition() {
        const { appState } = AppData as AppSetup;
        const enableLikeDislike = appState?.getAppApiConfig()?.appConfig?.enableLikeDislike;
        if (!enableLikeDislike) return;

        const watchNextVisible = this.tag('WatchNextThumb').visible;
        if (watchNextVisible) {
            this._videoFeedback.patch({ flexItem: false, y: 548, x: -44 });
            this._videoFeedback.setSmooth('alpha', 1);
            this.tag('FeedbackOverlay').setSmooth('alpha', 1);
            this.tag('FeedbackOverlay').patch({ visible: true, y: 620 });
        } else {
            this._videoFeedback.patch({
                flexItem: { marginTop: 14, marginLeft: -10 },
                visible: true,   
                y: 0,         
                x: 0,         
            });
            this._videoFeedback.setSmooth('alpha', 1); 
            this.tag('FeedbackOverlay').setSmooth('alpha', 0);
            this.tag('FeedbackOverlay').patch({ visible: false });
        }
    }

    disableSkip = () => {
        if (this.checkOnce) this.hideController();
        this.enableSkip = false;
        this.checkOnce = false;
        this.showSkipButton(false);
    };

    showSkipButton = (visible: boolean) => {
        if (visible && this.tag('FTTrickPlayUI').visible) return;
        if (visible && this._getState() === 'PlaylistState') return;
        this.tag('SkipTitles').visible = visible;
    };

    focusFirstTime = () => {
        if (this.checkOnce) return;
        this.checkOnce = true;
        const { appState } = AppData as AppSetup;
        const enableLikeDislike = appState?.getAppApiConfig()?.appConfig?.enableLikeDislike;
        if (
            this.tag('WatchNextThumb').visible &&
            this.tag('SkipTitles').visible &&
            this.tag('SkipTitles').label === 'WATCH CREDITS'
        ) {
            this._setState('WatchNextState');
        } else if (enableLikeDislike && this.tag('FeedbackOverlay').visible) {
            this._setState('FeedbackState');
        } else if (this.tag('SkipTitles').visible && this.tag('SkipTitles').label === 'SKIP INTRO') {
            this._setState('SkipState');
        }
        this._refocus();
    };

    $watchNextAction() {
        if (this.isNavigatingToNextVideo) return;
        this.isNavigatingToNextVideo = true;
        this.clearWatchNextTimer();
        this.checkOnce = false;
        Logger.processUserAction('clickedNextVideoPreview', this._getActionKey());
        this.$next();
        setTimeout(() => { this.isNavigatingToNextVideo = false; }, 1500);
    }

    watchNextTimer() {
        clearTimeout(this.watchNextTimeOut);
        this.watchNextTimeOut = setTimeout(() => {
            Logger.processUserAction('clickedNextVideoPreview', this._getActionKey());
            this.$next();
        }, 10000);
    }

    clearWatchNextTimer() {
        if (this.watchNextTimeOut) clearTimeout(this.watchNextTimeOut);
        this.watchNextTimerStarted = false;
        this.tag('WatchNextThumb').pauseProgress();
          this.updateFeedbackPosition(); 
    }

    updateWatchNextThumbPosition() {
        this.tag('WatchNextThumb').y = this.tag('FTTrickPlayUI').visible ? 345 : 500;
    }

    preloadNextItemImage = async (retryCount = 0) => {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        if (!this.nextItemImageUrl) {
            const nextItem = await app?.findNextItem();
            if (nextItem) this.nextItemImageUrl = nextItem.bg_image_landscape;
            if (!this.nextItemImageUrl && retryCount < 10) {
                this.preloadNextItemTimer = setTimeout(() => {
                    this.preloadNextItemImage(retryCount + 1);
                }, 2000);
            }
        }
    };

    startFFREWTimer = () => {
        this.checkOnce = false;
        this.disableSkip();
        const { appConfig } = AppData as AppSetup;
        if (!this.ffRewTimerId) {
            this.ffRewTimerId = setInterval(() => { this.forwardRewind(); }, 100);
            if (appConfig.enableTrickPlay) {
                this.tag('FTTrickPlayUI').show();
                this.updateWatchNextThumbPosition();
                if (this.tag('WatchNextThumb').visible) {
                    this.tag('FeedbackOverlay').setSmooth('alpha', 0);
                    this.tag('FeedbackOverlay').patch({ visible: false });
                    this._videoFeedback.setSmooth('alpha', 0);
                }
            }
        }
    };

    stopFFREWTimer = () => {
        clearInterval(this.ffRewTimerId);
        this.ffRewTimerId = null;
        // this.tag('SpeedText').visible = false;

        this.tag('ControlWrapper.Controls.ProgressWrapper.Progressbar.Circle').patch({
            w: 22,
            h: 22,
            shader: { type: Lightning.shaders.RoundedRectangle, radius: 11 },
            SpeedLabel: {
                mountX: 0.5,
                mountY: 0.5,
                x: 11,
                y: 11,
                visible: false,
                text: { text: '' }
            }
        });
    };

    commitSeekAndPause() {
        if (Math.abs(this.seekMultiplier) > 0) {
            this.stopFFREWTimer();
            this.currentTimeExit = this.finalSeekJumpValue;
            this.seekMultiplier = 0;
            this.setCurrentTime(this.finalSeekJumpValue);
            this.ftStreamingPlayer.pause();
            this.setPlayerState(PLAYERSTATE.PAUSED);
        }
    }

    forwardRewind = () => {
        const { appConfig } = AppData as AppSetup;
        if (this.seekMultiplier === 0) return;

        const speed = this.ffRwdSpeed[Math.abs(this.seekMultiplier)];
        const speedLabel = `x${speed}`
        const multiplier = speed * 10 * (this.seekMultiplier > 0 ? 1 : -1);

        this.finalSeekJumpValue += multiplier;
        const videoDuration = this.videoEl!.duration;
        let exitAndplay = false;

        if (this.finalSeekJumpValue > videoDuration - 10) {
            this.finalSeekJumpValue = videoDuration - 10;
            exitAndplay = true;
            Logger.processUserAction('playerFastForward_autoStoppingAtVideoEnd');
        } else if (this.finalSeekJumpValue < 0) {
            this.finalSeekJumpValue = 0;
            exitAndplay = true;
            Logger.processUserAction('playerRewind_autoStoppingAtVideoStart');
        }

        const curTime = Math.round(this.finalSeekJumpValue);
        const durTime = Math.round(videoDuration);
        this._updateProgress(curTime, durTime);

        if (appConfig.enableTrickPlay) {
            this.tag('FTTrickPlayUI').setPlayerTime(curTime);
        }

        this.tag('ControlWrapper.Controls.ProgressWrapper.Progressbar.Circle').patch({
            w: 32,
            h: 32,
            shader: { type: Lightning.shaders.RoundedRectangle, radius: 16 },
            SpeedLabel: {
                mountX: 0.5,
                mountY: 0.5,
                x: 16,
                y: 16,
                visible: true,
                text: {
                    text: speedLabel,
                    textColor: 0xff000000,
                    textAlign: 'center',
                    fontSize: 14
                }
            }
        });
        
        const timeStrArr = Helper.secondsToDisplayReadyTime(this.finalSeekJumpValue).split(':');
        // Hide SpeedText display while keeping the code for future use
        // this.tag('SpeedText').patch({ Text: { text: { text: `${speed}X : ${timeStrArr[0]}h : ${timeStrArr[1]}m : ${timeStrArr[2]}s` } } });
        // if (!this.tag('SpeedText').visible) this.tag('SpeedText').visible = true;

        if (exitAndplay) this.$playPause();
    };

    async playPreviousVideo() {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        app.navigation.setPreviousVideoWatchDuration(Math.round(this.currentTimeExit));
        this.showHideVideoLoading(true);
        this.sendMetricsOnEnd();
        this.ftStreamingPlayer.pause();
        this.resetAds();
        this.resetPlayer();
        appState?.sessionTimeState.stopTimer()
        const vodItem: ItemNode = await app?.getPrevItem()!;
        Log.info('playPrevVideo: ', vodItem);
        appState.player.vodAutoPlayed = false;
        setTimeout(() => {
            if (vodItem.feed_type == 'video') {
                Router.navigate('video-screen/' + vodItem.node_id + '_r_' + new Date().getTime(), false);
            }
        }, 300);
    }

    async playNextVideo(isAutoPlayed: boolean) {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        app.navigation.setPreviousVideoWatchDuration(Math.round(this.currentTimeExit));
        this.showHideVideoLoading(true);
        this.sendMetricsOnEnd();
        this.ftStreamingPlayer.pause();
        this.resetAds();
        this.resetPlayer();
        appState?.sessionTimeState.stopTimer()
        const vodItem: ItemNode = await app?.getNextItem()!;
        Log.info('playNextVideo: ', vodItem);
        appState.player.vodAutoPlayed = isAutoPlayed;
        setTimeout(() => {
            if (vodItem.feed_type == 'video') {
                Router.navigate('video-screen/' + vodItem.node_id + '_r_' + new Date().getTime(), false);
            }
        }, 300);
    }

    closeVideo(skipCloseTracker = false, resetFullPlayer=false) {
        if (!skipCloseTracker) {
            this.hitCloseTracker()
            this.sendMetricsOnEnd()
        }
        this.focusedRowIndex = 1;
        this._rowIndex = 1;
        this.stopFFREWTimer(); // added for the fix XFIN-681
        this.tag("FTTrickPlayUI").hide(); // IPTV-2411 - Hide trickplay UI explicitly
        this.resetAds() // added for the fix XFIN-681 resetting the ads on exiting the player screen.
        if (this.bugAds) {
            this.bugAds.deInit();
            this.bugAds = null;
        }
        if (this.pauseAds) {
            this.pauseAds.deInit();
            this.pauseAds = null;
        }
        this.resetPlayer(resetFullPlayer)
    }

    resetPlayer(resetFullPlayer = false) {
        this.tag('VideoCCSection').removeCaption() // XFIN-677 - clearing the captions first and then reset the player.
        this._removeEventListener()
        this.ftStreamingPlayer.destroy(resetFullPlayer)
        this.setPlayerState(PLAYERSTATE.NONE)
        this.hideVideo()
    }

    handleBackNavigation() {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        appState?.sessionTimeState.stopTimer()
        this.closeVideo();
        setTimeout(() => { app?.handleBackNavigation(); }, 100);
    }

    getErrorCode(error: any) {
        try { return error.detail.message.error.code; } catch (e) { return ''; }
    }

    getErrorMsg(error: any) {
        try { return error.detail.message.error.message; } catch (e) { return ''; }
    }

    getErrorXhr(error: any) {
        try { return error.detail.message.error.data; } catch (e) { return null; }
    }

    handlePlayerError(error: CustomEvent) {
        let errType = '';
        let errorDetailStr = '';
        let isFatal = false;

        try {
            if (error?.detail?.type) {
                if (error.detail.type == 'M(PEG)-DASH') {
                    errType = 'Dash';
                    errorDetailStr = JSON.stringify({ type: 'dashError', message: this.getErrorMsg(error), errorCode: this.getErrorCode(error) });
                    isFatal = true;
                } else if (error.detail.type == 'HLS') {
                    errType = error.detail.type;
                    errorDetailStr = JSON.stringify({ type: error.detail.type, message: error.detail.message });
                    isFatal = error.detail.data[1].fatal;
                } else if (error.detail.type == 'MP4') {
                    isFatal = true;
                    errType = error.detail.type;
                }
            }
            Logger.processUserAction(isFatal ? 'playbackfailed' : 'videoError', this._getActionKey(), errType, errorDetailStr);
            if (isFatal) this.startTimerForHandleFatalError({ error, errType, errorDetailStr });
        } catch (e) { /* silent */ }
    }

    startTimerForHandleFatalError(errObj: any) {
        const { appConfig } = AppData as AppSetup;
        clearTimeout(this.errorNextItemTimer);
        this.errorNextItemTimer = setTimeout(() => {
            if (appConfig?.enableNetworkDisconnectionCheck == true) {
                this._handleNetworkChange(errObj);
            } else {
                this.handleNextOrPreviousError(errObj);
            }
        }, 10000);
    }

    handleNextOrPreviousError(errorObj: { error: any; errType: string; errorDetailStr: string }) {
        const { appConfig, appState, platform } = AppData as AppSetup;
        const { error, errType, errorDetailStr } = errorObj;
        Log.info('Video Error: ', error);
        platform?.sendMetrics('error', { errorType: 'network', code: errType, description: errorDetailStr });
        if ((appConfig as Config).enableRetries && this.retries < this.maxRetries) {
            this.retries++;
            Log.info('Retrying video playback, retry count: ', this.retries);
            Logger.processUserAction('retryingOnVideoOnError' + errType);
            this.resetPlayer();
            this._resumePlayer(this.currentTimeExit);
            return;
        }
        if (appState?.player.currentUserAction == 'previous') {
            Logger.processUserAction('autoPlayingPreviousVideoOnError' + errType);
            this.playPreviousVideo();
        } else {
            Logger.processUserAction('autoPlayingNextVideoOnError' + errType);
            this.playNextVideo(true);
        }
    }

    _handleNetworkChange(
        errorObj: { error: any; errType: string; errorDetailStr: string } | undefined = undefined
    ) {
        const { platform } = AppData as AppSetup;
        const pauseTime = this.currentTimeExit;
        platform?.networkManager.healthCheck(true, this, {
            success: (isFailedTriggered: boolean) => {
                if (isFailedTriggered) {
                    this.isDisconnected = false;
                    this._resumePlayer(pauseTime);
                } else {
                    if (errorObj) this.handleNextOrPreviousError(errorObj);
                }
            },
            failed: () => {
                this.trickplayAutoHideHandler(null);
                this.hideController();
                this._setState('');
                this.isDisconnected = true;
                this.resetPlayer();
            }
        });
    }

    updateVideoResumeTime = (curTime: any, durTime: any, updateOn: any) => {
        const { appConfig, appState } = AppData as AppSetup;
        const appApiConfig = appState?.getAppApiConfig();
        if (!appConfig?.enableResumeVideo) return;
        if (durTime <= appApiConfig?.appConfig?.resumeVidMinDuration) return;

        const key = this.videoInfo.node_id;
        if (curTime < durTime - 240) {
            const shouldSave = updateOn !== 'videoprogress' || (curTime % 10 == 0 && curTime !== 0);
            if (shouldSave) {
                if (appConfig.useLocalStorage == true) localStorage.setItem(key, curTime);
                else Helper.setGeneralCookie(key, curTime, 365);
            }
        } else {
            if (appConfig.useLocalStorage == true) localStorage.removeItem(key);
            else Helper.removeCookie(key);
        }
    };

    hitCloseTracker() {
        const { appState } = AppData as AppSetup;
        const app: AppModel = appState?.getApp()!;
        const previousVodInfo = app.navigation.getPreviousVideoInfo();
        if (!previousVodInfo) return;
        app.navigation.setPreviousVideoWatchDuration(Math.round(this.currentTimeExit));
        Logger.logCloseVideoView(app.navigation.getPreviousVideoInfo());
        app.navigation.resetPreviousVideoInfo();
    }

    sendMetricsOnEnd() {
        const { platform } = AppData as AppSetup;
        platform?.sendMetrics('stopContent', {
            vodInfo: this.videoInfo,
            watchedDuration: this.currentTimeExit,
            completed: this.currentTimeExit >= this.videoInfo.runtime - 240,
            totalDuration: this.videoInfo.runtime
        });
    }

    _getActionKey() {
        return this.videoInfo ? `${this.videoInfo.node_id}_${this.currentTimeExit}` : '';
    }

    getCurrentTime = () => {
        return this.videoEl ? this.videoEl.currentTime : 0;
    };

    setCurrentTime = (currentTime: any) => {
        if (this.videoEl) this.videoEl.currentTime = currentTime;
    };

    _addControlButtons() {
        const { appConfig } = AppData as AppSetup;
        const buttons = Helper.buttons;
        this.buttonIndexMapper = {};
        const items: any[] = [];

        buttons.map((button: any, index: number) => {
            if (button.action == '$closedcaption' && appConfig?.disableCC) return;
            this.buttonIndexMapper[button.action] = index;
            items.push({
                type: ControlIcon,
                x: button.x - button.iconWidth / 2,
                y: button.y - button.iconHeight / 2,
                collision: true,
                w: button.iconWidth,
                h: button.iconHeight,
                color: 0x000000,
                icons: button.iconsvg,
                sprite: button.sprite,
                action: button.action,
                tts: button.tts
            });
        });

        this.tag('MediaButtons').items = items;
        this.tag('MediaButtons').selectedIndex = 4;
    }

    handleAppSuspend() { this.closeVideo(); }
    handleAppResumed() { this._active(); }

    handleInactiveEvent() {
        if (this.playerState == PLAYERSTATE.PLAYING) this.ftStreamingPlayer.pause();
        this.closeVideo();
        this.handleBackNavigation();
    }

    checkForAds = (adtype = 'all', resumeTime: any) => {
        const { appConfig, appState } = AppData as AppSetup;
        Logger.printLog('info', 'checkForAds called... disableAds ', appConfig.disableAds);
        const app = appState?.getApp();
        const freeWheelAds = app?.freeWheelAds;
        freeWheelAds.breakPosition = 0;

        if (appConfig.disableAds == false) {
            if (appConfig.enableMidrolls == true) app.adHandler.getCuePoints(this.videoInfo);
            if (appConfig.adSdkToUse == 'ima') {
                app.imaAdHandler.requestAds(this.videoInfo, adtype);
            } else {
                if (freeWheelAds) {
                    if (freeWheelAds.player) freeWheelAds.player.cleanUp();
                    this.screen = 'ad';
                    freeWheelAds.initAds(false, this.videoInfo, this);
                } else {
                    this._resumePlayer(resumeTime);
                }
            }
        } else {
            this._resumePlayer(resumeTime);
        }
    };

    isPaused = () => !!this.videoEl?.paused;

    resumeVideoPlayback = (startTime: any, callingMethod = '') => {
        Logger.printLog('info', 'resumeVideoPlayback called... ' + startTime);
        this.screen = 'player';
        const { appConfig } = AppData as AppSetup;
        if (this.isPausedOnAd) Logger.processUserAction('adBreakEnd', startTime);
        this.isPausedOnAd = false;
        if (appConfig?.adSdkToUse == 'freewheel' && appConfig.enableWaterfalling) this.resetIma();
        if (appConfig?.testEnableNativePlayer == true && startTime > 0 && this.isPlayerEnabled()) {
            this.showVideo();
            this.ftStreamingPlayer.play();
            this.setPlayerState(PLAYERSTATE.PLAYING);
        } else {
            this._resumePlayer(startTime);
        }
    };

    isPlayerEnabled = () => !!(
        this.ftStreamingPlayer?.src?.length > 0 &&
        this.ftStreamingPlayer?.videoEl?.src
    );

    // $videoPlayerLoadingState(loadState: boolean) {
    //     this.showHideVideoLoading(loadState);
    // }

    $videoPlayerTimeUpdate(curTime: any) {
        const { appConfig, appState } = AppData as AppSetup;
        const app = appState?.getApp();
        const ads = app?.ads;

        if (appConfig.enableMidrolls == true) {
            if (appConfig.disableAds == false && Helper.isFusePrefetchEnabled()) {
                this.checkAndPrefetch(curTime);
            }
            if ($.inArray(curTime, ads.currentVodCuePoints) !== -1) {
                Logger.printLog('info', 'matched cuepoint at ' + curTime, '');
                appState.player.pausedTime = curTime;
                if (appConfig.adSdkToUse == 'freewheel' && ads.midAdPlaying == false) {
                    const freeWheelAds = app?.freeWheelAds;
                    if (!Helper.isFusePrefetchEnabled()) {
                        freeWheelAds.breakPosition++;
                        freeWheelAds.requestAdsCustom(this);
                    } else {
                        const cuePointTime = appConfig.prefetchAds ? curTime + appConfig.prefetchTiming : curTime;
                        if (freeWheelAds.noAds > 0) {
                            freeWheelAds.requestFallbackIma(this.videoInfo, freeWheelAds.noAds, cuePointTime);
                        }
                    }
                }
                ads.currentVodCuePoints.splice($.inArray(curTime, ads.currentVodCuePoints), 1);
            } else if (appConfig.prefetchAds && $.inArray(curTime, ads.currentVodPlayPoints) !== -1) {
                appState.player.pausedTime = curTime;
                if (appConfig.adSdkToUse == 'freewheel' && ads.midAdPlaying == false) {
                    app?.freeWheelAds.player.playMidroll();
                }
                ads.currentVodPlayPoints.splice($.inArray(curTime, ads.currentVodPlayPoints), 1);
            }
            if (appConfig.adSdkToUse == 'ima' && appConfig.useVmap == false && appConfig.disableAds == false) {
                app.imaAdHandler.cuePointsManager?.updateCurrentTime(curTime);
            }
        }
        this.updateSkipIntroAndCredits(curTime);

        if (this.bugAds) {
            this.bugAds.handleAdDisplay(curTime);
        }
    }

    checkAndPrefetch(curTime: number) {
        const { appConfig, appState } = AppData as AppSetup;
        const app = appState?.getApp();
        const ads = app?.ads;
        for (let i = 0; i < ads.currentVodPFPoints.length; i++) {
            const pfTime = ads.currentVodPFPoints[i];
            const cueTime = ads.currentVodCuePointsCopy[i];
            if (curTime >= pfTime && curTime < cueTime && !this.prefetched.has(pfTime)) {
                this.prefetched.add(pfTime);
                Logger.printLog('info', `[FUSE PREFETCH] Prefetching ad for cue at ${cueTime}`, '');
                if (appConfig.adSdkToUse == 'ima' && app.imaAdHandler.cuePointsManager != null) {
                    app.imaAdHandler.cuePointsManager.requestFusePrefetch(ads?.currentVodPFInfo[pfTime].playTime);
                }
                if (appConfig.adSdkToUse == 'freewheel' && ads.midAdPlaying == false) {
                    const freeWheelAds = app?.freeWheelAds;
                    appState.player.pausedTime = cueTime;
                    freeWheelAds.breakPosition++;
                    freeWheelAds.isFusePF = true;
                    freeWheelAds.pfTime = pfTime;
                    freeWheelAds.requestPrefetchAds(this, pfTime);
                }
                break;
            }
        }
    }

    pauseContent() {
        const { appState, appConfig } = AppData as AppSetup;
        if (this.bugAds?.adDisplayedStatus) {
            this.bugAds.dismissAd();
        }
        this.pauseAds?.onResumed();
        this.screen = 'ad';
        this._refocus();
        this.isPausedOnAd = true;
        appState?.sessionTimeState.stopTimer()
        Logger.processUserAction('adBreakStart', appState.player.pausedTime);
        if (appConfig?.testEnableNativePlayer) {
            this.ftStreamingPlayer.pause();
            this.hideVideo();
            this.setPlayerState(PLAYERSTATE.NONE);
        } else {
            try { this.resetPlayer(); } catch (e) { /* silent */ }
        }
    }

    playContent() { this.screen = 'player'; }
    hideLoader() { /* noop */ }
    showLoader() { /* noop */ }

    resetAds() {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        const freeWheelAds = app?.freeWheelAds;
        if (freeWheelAds?.player) {
            freeWheelAds.breakPosition = 0;
            freeWheelAds.player.onContentVideoEnded();
        }
        this.resetIma();
    }

    resetIma() {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        this.isPausedOnAd = false;
        if (app.imaAdHandler) app.imaAdHandler.resetIma();
    }

    _handleDrag(details: any, component: any) {
        if (component?.__ref == 'Circle') {
            this._updateProgressButtonPosition(details, component);
        }
    }

    _updateProgressButtonPosition(details: any, _component: any) {
        const buttonComp = this.tag('ControlWrapper.Controls.ProgressWrapper.Progressbar.Circle');
        const delta = details.position.x * (app.application.stage.w / window.innerWidth);
        buttonComp.patch({ x: Math.min(Math.max(delta - 200, 0), 1920 - 200) });
        this.startDragTimeout();
    }

    startDragTimeout() {
        this.stopDragTimeout();
        this.showController(false);
        this.isDragging = true;
        this.dragTimerId = setTimeout(() => { this.stopDragTimeout(); }, 1000);
    }

    stopDragTimeout() {
        clearTimeout(this.dragTimerId);
        this.dragTimerId = null;
        this.isDragging = false;
        this.showController(true);
        const buttonComp = this.tag('ControlWrapper.Controls.ProgressWrapper.Progressbar.Circle');
        const perc = buttonComp.x / (1920 - 200);
        const seekTime = Math.min(Math.round(this.videoEl!.duration * perc), this.videoEl!.duration - 10);
        this.setCurrentTime(seekTime);
        this._updateProgress(seekTime, this.videoEl!.duration);
    }

    _handleClick(target: any, localCoords?: any) {
        if (target.action) {
            this[target.action](true, false);
        } else if (target.ref == 'BackButton') {
            this.handleBackNavigation();
        } else if (target.ref == 'Container') {
            this.showController();
        } else if (target.ref == 'ProgressWrapper' && localCoords?.x !== undefined) {
            this._seekToClickPosition(target, localCoords);
        }
    }

    _seekToClickPosition(target: any, localCoords: any) {
        const precision = this.stage.getRenderPrecision() / this.stage.getOption('devicePixelRatio');
        const clickX = localCoords.x / precision + this.core.renderContext.px - target.core.renderContext.px;
        const progress = Math.min(Math.max(clickX / target.finalW, 0), 1);
        const buttonComp = this.tag('ControlWrapper.Controls.ProgressWrapper.Progressbar.Circle');
        buttonComp.patch({ x: progress * target.finalW });
        this.showController(true);
        this.stopDragTimeout();
    }

    
    _handleExitKey() {
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        this.stopFFREWTimer();
        this.hitCloseTracker();
        app?.handleAppExit();
        return true;
    }

    $focusMediaButtons() {
        this._setState('MediaButtonsState');
    }

    static override _states(): any[] {
        return [
            class CCSettingsState extends this {
                override $enter(event: any) {
                    this.tag('CCSettingsOverlay').visible = true
                    this.tag('CCSettingsOverlay').setSmooth('alpha', 1)
                    // this.tag("ControlWrapper").setSmooth('alpha', 0)
                    Logger.processUserAction("ccSettingsOverlayOpened", this._getActionKey());
                    this.startInactivityTimer();
                }
                override $exit(event: any) {
                    this.clearInactivityTimer();
                    this.tag('CCSettingsOverlay').visible = false
                    this.tag('CCSettingsOverlay').setSmooth('alpha', 0)
                    // this.tag("ControlWrapper").setSmooth('alpha', 1)
                    Logger.processUserAction("ccSettingsOverlayClosed", this._getActionKey());
                }
                override _getFocused() {
                    return this.tag('CCSettingsOverlay')
                }
                override _captureKey(e: KeyboardEvent): boolean | void {
                    this.startInactivityTimer();
                    return false;
                }
                override _handleBack(e: KeyboardEvent): boolean | void {
                    this.$closeCCOverlay();
                }
                override _handleKey(e: KeyboardEvent): boolean | void {
                    if (e.keyCode == KeyCodes.KEY_EXIT) {
                        this.$closeCCOverlay();
                        return true
                    }
                    return true
                }
                override _handleClick(target: any) {
                    if (target.ref == 'BackButton') {
                        this.$closeCCOverlay();
                    }
                }
            },
            class MediaButtonsState extends this {
                override $enter() {
                    this.tag('MediaButtons').patch({ smooth: { alpha: 1, h: 30 } });
                    this.tag('Controls.VideoPlayList').patch({ smooth: { alpha: 1 } });
                    this.tag('Controls').patch({
                        smooth: { y: [800, { duration: 0.3, timingFunction: 'ease-out' }] }
                    });
                    this.tag('SkipTitles').patch({
                        smooth: {y: [720, { duration: 0.3, timingFunction: 'ease-out' }]}
                    })
                    this.tag('WatchNextThumb').patch({
                        smooth: {y: [500, { duration: 0.3, timingFunction: 'ease-out' }]}
                    })
                    this.tag('Controls.VideoPlayList')?.setRowMetaAlpha?.(0);
                }
                override _getFocused() {
                    if (this.bugAds?.adDisplayedStatus) return this;
                    return this.tag('MediaButtons');
                }
                override _handleUp() {
                    const enableLikeDislike = (AppData as AppSetup).appState?.getAppApiConfig()?.appConfig?.enableLikeDislike;
                    if (this.tag('SkipTitles').visible) {
                        this._setState('SkipState');
                    } else if (this.tag('WatchNextThumb').visible) {
                        this._setState('WatchNextState');
                    } else if (this.isTrickplayAvailable()) {
                        this.tag('FTTrickPlayUI').show(true);
                        this.updateWatchNextThumbPosition();
                        this._setState('TrickPlayState');
                    } else if (enableLikeDislike) {
                        this._setState('FeedbackState');
                    }
                }
                override _handleDown() {
                    this._setState('PlaylistState');
                }
            },

            class TrickPlayState extends this {
                override $enter() {
                    this.clearControllerTimeout();
                    this.startInactivityTimer();
                    this.tag('Controls').patch({
                        smooth: { y: [900, { duration: 0.3, timingFunction: 'ease-out' }] }
                    });
                    this.tag('MediaButtons').patch({ smooth: {alpha: 0} });
                    this.tag('Controls.VideoPlayList').patch({ smooth: {alpha: 0} });
                    this.tag('SkipTitles').visible = false;
                    this.commitSeekAndPause()
                    if (this.tag('FTTrickPlayUI').visible) {
                        this.tag('FTTrickPlayUI').setFocused(true);
                    }
                    if (this.tag('WatchNextThumb').visible) {
                        this.tag('FeedbackOverlay').setSmooth('alpha', 0);
                        this.tag('FeedbackOverlay').patch({ visible: false });
                        this._videoFeedback.setSmooth('alpha', 0);
                    }
                }
                override $exit() {
                    this.clearInactivityTimer();
                    if (!this._trickPlayToFeedback) {
                        this.tag('FTTrickPlayUI').hide();
                        this.updateWatchNextThumbPosition();
                        if (this.enableSkip) this.tag('SkipTitles').visible = true;
                    } else {
                        this.tag('FTTrickPlayUI').setFocused(false);
                    }
                    this._trickPlayToFeedback = false;
                    if (this.tag('WatchNextThumb').visible) {
                        this.updateFeedbackPosition();
                    }
                }
                override _getFocused() { return this.tag('FTTrickPlayUI'); }

                override _handleUp(): boolean | void {
                    this.startInactivityTimer();
                    const enableLikeDislike = (AppData as AppSetup).appState?.getAppApiConfig()?.appConfig?.enableLikeDislike;
                    if (enableLikeDislike) {
                        this._trickPlayToFeedback = true;
                        this._setState('FeedbackState');
                    }
                    return true;
                }

                override _handleDown() {
                    this.clearInactivityTimer();
                    if (this.tag('WatchNextThumb').visible) {
                        this._setState('WatchNextState');
                    } else if (this.enableSkip) {
                        this._setState('SkipState');
                    } else {
                        this._setState('MediaButtonsState');
                        this.showController(true);
                    }
                }
                override _handleLeft(): boolean | void {
                    this.startInactivityTimer(); 
                    return false;
                }

                override _handleRight(): boolean | void {
                    this.startInactivityTimer();   
                    return false;
                }

                override _handleKey(e: KeyboardEvent): boolean | void {
                    this.startInactivityTimer();   
                    return false;
                }
                override _handleBack(): boolean | void {
                    this.clearInactivityTimer();
                    this._setState('MediaButtonsState');
                    this.showController(true);
                }
            },

            class SkipState extends this {
                override $enter() {
                    this.clearControllerTimeout();
                    this.tag('MediaButtons').patch({ smooth: { alpha: 1 } });
                    this.tag('Controls.VideoPlayList').patch({ smooth: { alpha: 1 } });
                    this.tag('Controls').patch({
                        smooth: { y: [800, { duration: 0.3, timingFunction: 'ease-out' }] }
                    });
                }
                override _getFocused() { return this.tag('SkipTitles'); }
                override _handleLeft(): boolean | void {
                    const enableLikeDislike = (AppData as AppSetup).appState?.getAppApiConfig()?.appConfig?.enableLikeDislike;
                    if (this.tag('WatchNextThumb').visible && enableLikeDislike) {
                        this._setState('FeedbackState');
                        return true;
                    }
                    return true;
                }
                override _handleUp() {
                    if (this.tag('WatchNextThumb').visible) {
                        this._setState('WatchNextState');
                    } else if (this.isTrickplayAvailable()) {
                        this.tag('FTTrickPlayUI').show(true);
                        this.updateWatchNextThumbPosition();
                        this._setState('TrickPlayState');
                    } else {
                        return true; 
                    }
                }
                 override _handleDown() {
                    this._setState('MediaButtonsState');
                }
                override _handleBack(): boolean | void {
                    if (this.tag('WatchNextThumb').visible) {
                        this.clearWatchNextTimer();
                        this.hideControlsOnPlayNext = true;
                        this.creditsWatched = true;
                        this.tag('WatchNextThumb').visible = false;
                        this.updateFeedbackPosition();
                    }
                    this._setState('MediaButtonsState');
                    this.hideController();
                }
            },

            class WatchNextState extends this {
                override $enter() { this.clearControllerTimeout(); this.clearInactivityTimer(); }
                override _getFocused() { return this.tag('WatchNextThumb'); }
                override _handleLeft(): boolean | void {
                    const enableLikeDislike = (AppData as AppSetup).appState?.getAppApiConfig()?.appConfig?.enableLikeDislike;
                    if (enableLikeDislike) {
                        this._setState('FeedbackState');
                    }
                    return true;
                }
                override _handleUp(): boolean | void {
                    return true;
                }

                override _handleDown() {
                    if (this.tag('SkipTitles').visible) {
                        this._setState('SkipState');
                    } else {
                        this._setState('MediaButtonsState');
                    }
                }

                override _handleBack(): boolean | void {
                    this.clearWatchNextTimer();
                    this.hideControlsOnPlayNext = true;
                    this.creditsWatched = true;
                    this.tag('WatchNextThumb').visible = false;
                    this.updateFeedbackPosition();
                    this._setState('MediaButtonsState');
                    this.hideController();
                }
            },

            class PlaylistState extends this {
                override $enter() {
                    this.clearControllerTimeout();
                     this.startInactivityTimer();
                    this.tag('MediaButtons').patch({ smooth: { alpha: 0, h: 15 } });
                    this.tag('Controls.VideoPlayList').patch({ smooth: { alpha: 1 } });
                    this.tag('Controls').patch({
                        smooth: { y: [450, { duration: 0.3, timingFunction: 'ease-out' }] }
                    });
                    this.tag('Controls.VideoPlayList')?.setRowMetaAlpha?.(1);
                    this.tag('SkipTitles').patch({
                        visible: false,
                        alpha: 0,
                    })
                    if (this.tag('FTTrickPlayUI').visible) {
                        this.tag('SkipTitles').visible = false;
                        this.commitSeekAndPause();
                        this.tag('FTTrickPlayUI').hide();
                        this.updateWatchNextThumbPosition();
                    }
                     this.tag('WatchNextThumb').patch({
                        smooth: {y: [180, { duration: 0.3, timingFunction: 'ease-out' }]}
                    })

                    const enableLikeDislike = (AppData as AppSetup).appState?.getAppApiConfig()?.appConfig?.enableLikeDislike;
                    this.tag('FeedbackOverlay').setSmooth('alpha', 0);
                    this._videoFeedback.setSmooth('alpha', (enableLikeDislike && !this.tag('WatchNextThumb').visible) ? 1 : 0);
                }

                override $exit() {
                    this.clearInactivityTimer();
                    const { appState } = AppData as AppSetup;
                    const enableLikeDislike = appState?.getAppApiConfig()?.appConfig?.enableLikeDislike;
                    if (this.enableSkip) {
                        this.tag('SkipTitles').patch({ y: 720, alpha: 0, visible: true });
                        this.tag('SkipTitles').setSmooth('alpha', 1);
                    }
                    if (enableLikeDislike) {
                        const watchNextVisible = this.tag('WatchNextThumb').visible;
                        if (watchNextVisible) {
                            this._videoFeedback.patch({ visible: true });
                            this._videoFeedback.setSmooth('alpha', 1);
                            this.updateFeedbackPosition();
                        }
                    }
                }

                override showController(autoHide = true) {
                    super.showController(false);
                    this.tag('SkipTitles').alpha = 0;
                    const enableLikeDislike = (AppData as AppSetup).appState?.getAppApiConfig()?.appConfig?.enableLikeDislike;
                    this.tag('FeedbackOverlay').setSmooth('alpha', 0);
                    this._videoFeedback.setSmooth('alpha', (enableLikeDislike && !this.tag('WatchNextThumb').visible) ? 1 : 0);
                }
                override _getFocused() { return this.tag('Controls.VideoPlayList'); }

                override _handleUp() {
                    this.clearInactivityTimer();    
                    this._setState('MediaButtonsState');
                    // this.hideController();
                }

                override _handleDown(): boolean | void {
                    this.startInactivityTimer();        
                    return false;
                }

                override _handleLeft(): boolean | void {
                    this.startInactivityTimer();        
                    return false;
                }

                override _handleRight(): boolean | void {
                    this.startInactivityTimer();        
                    return false;
                }

                override _handleKey(e: KeyboardEvent): boolean | void {
                    this.startInactivityTimer();          
                    return false;
                }

                override _handleBack(): boolean | void {
                    this.clearInactivityTimer();     
                    this._setState('MediaButtonsState');
                    this.hideController();
                }
            },

            class ItemInfoState extends this {
                override $enter() {
                    this.tag('TitleContainer').setSmooth('alpha', 0);
                    this.tag('ItemInfo').show();
                    // Auto-hide after 10s of inactivity (like trickplay / playlist).
                    this.startInactivityTimer();
                }
                override $exit() {
                    this.clearInactivityTimer();
                    this.tag('TitleContainer').setSmooth('alpha', 1);
                    this.tag('ItemInfo').hide();
                }
                override _getFocused() { return this.tag('ItemInfo'); }
                override _captureKey(e: KeyboardEvent): boolean | void {
                    // Any interaction resets the inactivity auto-hide timer.
                    this.startInactivityTimer();
                    return false;
                }
                override _handleBack(): boolean | void { this._setState('MediaButtonsState'); }
                _handleClick(target: any) {
                    if (target.ref == 'BackButton') this._setState('MediaButtonsState');
                }
                override _handleKey(e: KeyboardEvent): boolean | void {
                    if (e.keyCode == KeyCodes.KEY_EXIT) return this._handleExitKey();
                    return true;
                }
            },

            class FeedbackState extends this {
                override $enter() {
                    this.clearControllerTimeout();
                    this.clearInactivityTimer();
                }

                override _handleRight(): boolean | void {
                    if(this.tag('WatchNextThumb').visible) {
                    this._setState('WatchNextState');
                    return true;
                    }
                    return true;
                }

                override _getFocused() {
                    return this._videoFeedback;
                }
                override _handleUp(): boolean | void {
                    return true;
                }
                override _handleDown() {
                    if (this.tag('FTTrickPlayUI').visible) {
                        this._setState('TrickPlayState');
                    } else {
                        this._setState('MediaButtonsState');
                        this.showController(true);
                    }
                }
                override _handleBack(): boolean | void {
                    this.tag('FeedbackOverlay').setSmooth('alpha', 0);
                    this.tag('FTTrickPlayUI').hide();
                    this.updateWatchNextThumbPosition();
                    if (this.tag('WatchNextThumb').visible) {
                        this.clearWatchNextTimer();
                        this.hideControlsOnPlayNext = true;
                        this.creditsWatched = true;
                        this.tag('WatchNextThumb').visible = false;
                        this.updateFeedbackPosition();
                    }
                    this._setState('MediaButtonsState');
                    this.showController(true);
                }
            }
        ];
    }
}
